var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    style: {
      width: 28
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f68903;}.cls-3{fill:#f68903;}.cls-4{fill:#f68903;}.cls-5{fill:#f68903;}.cls-6{fill:#f68903;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-7,.cls-8,.cls-9{mix-blend-mode:overlay;opacity:0.2;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 622.81,
    y1: 526.97,
    x2: 455.9,
    y2: 667.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 708.32,
    y1: 359.58,
    x2: 584.43,
    y2: 463.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 534.72,
    y1: 325.86,
    x2: 329.97,
    y2: 497.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 722.28,
    y1: 73.05,
    x2: 355.12,
    y2: 381.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 390.99,
    y1: 542.16,
    x2: 73.04,
    y2: 808.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 991.42,
    y1: 425.12,
    x2: 540.87,
    y2: 803.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 443.93,
    y1: 916.56,
    x2: 320.04,
    y2: 1020.51,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "539.87 699.42 718.03 596.57 539.87 493.71 361.72 596.57 539.87 699.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "557.68 462.66 557.68 256.94 735.84 359.8 735.84 565.52 557.68 462.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "522.06 256.94 343.9 359.8 343.9 565.52 522.06 462.66 522.06 256.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "539.87 0 147.85 226.02 326.01 328.88 539.87 205.72 753.68 329.11 931.83 226.26 539.87 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.12 956.55 308.28 1059.41 308.19 812.64 521.91 936.21 521.91 730.49 308.31 606.86 308.28 360 130.12 257.14 130.12 956.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "949.61 709.66 949.88 257.15 771.72 360.01 771.45 606.81 557.68 730.27 557.68 935.98 949.61 709.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "522.09 977.14 343.94 1080 343.94 874.28 522.09 977.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "539.87 699.42 718.03 596.57 539.87 493.71 361.72 596.57 539.87 699.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "557.68 462.66 557.68 256.94 735.84 359.8 735.84 565.52 557.68 462.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "522.06 256.94 343.9 359.8 343.9 565.52 522.06 462.66 522.06 256.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "539.87 0 147.85 226.02 326.01 328.88 539.87 205.72 753.68 329.11 931.83 226.26 539.87 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "130.12 956.55 308.28 1059.41 308.19 812.64 521.91 936.21 521.91 730.49 308.31 606.86 308.28 360 130.12 257.14 130.12 956.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "949.61 709.66 949.88 257.15 771.72 360.01 771.45 606.81 557.68 730.27 557.68 935.98 949.61 709.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "522.09 977.14 343.94 1080 343.94 874.28 522.09 977.14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logo.icon.bdc626fe6a0cff0e33e96bce252a0ee2.svg";
export { ForwardRef as ReactComponent };